/*************************************************/
/* BROCHURE PDF                                  */
/*************************************************/

export function brochurePdf($body) {
    let selectActiveClass;

    const init = function () {
        selectActiveClass = "custom-select--active";

        $(document).on("click", ".custom-select__current", function (e) {
            const that = $(this),
                $formContainer = that.parents(".custom-select");
            e.stopPropagation();
            e.preventDefault();
            if (!$formContainer.hasClass(selectActiveClass)) {
                closeCustomSelectMenus();
                $formContainer.addClass(selectActiveClass);
            } else {
                closeCustomSelectMenus();
            }
        });

        // Update selected values
        $(document).on("click", ".custom-select__list-item", function () {
            const that = $(this),
                url = that.attr("data-url"),
                label = that.attr("data-label"),
                icon = that.attr("data-icon"),
                $formContainer = that.parents(".custom-select__form"),
                $formActiveIcon = $formContainer.find(".custom-select__current .custom-select__icon"),
                $formActiveLabel = $formContainer.find(".custom-select__current .custom-select__label"),
                $formButton = $formContainer.find(".custom-select__button");

            if (label && url) {
                $formActiveIcon.css("background-image", "url(" + icon+")");
                $formActiveLabel.text(label);
                $formButton.attr("href", url);
            }
        });

        $(document).on("click", $body, function () {
            closeCustomSelectMenus();
        });

    };

    init();

    function closeCustomSelectMenus() {
        $(".custom-select").removeClass(selectActiveClass);
    }
}